module.exports = __webpack_public_path__ + "img/footer-bg.5615942f.svg";